import React, { useState, useEffect } from "react";
import { Button, Form, Icon } from "tabler-react";
import { Crud_Catalogos } from "../../herramientas/Crud_Catalogos";
import { NotificationManager } from "react-notifications";
import Select from "react-select";
import "./TractosForm.css";

const TractosForm = ({
  accion,
  elementos,
  cerrarModal,
  onSave,
  idTransportista: idTransportistaProp
}) => {
  const [formulario, setFormulario] = useState({
    placa: "",
    economico: "",
    marca: null,
    color: null,
    modelo: null
  });

  const [marcaOpciones, setMarcaOpciones] = useState([]);
  const [modeloOpciones, setModeloOpciones] = useState([]);
  const [colorsOpciones, setColorsOpciones] = useState([]);
  const [crudbutonEnable, setCrudbutonEnable] = useState(true);
  const [idTransportista, setIdTransportista] = useState(null);

  useEffect(() => {
    // Obtener idTransportista
    if (idTransportistaProp) {
      setIdTransportista(idTransportistaProp);
    } else {
      const usuario = JSON.parse(sessionStorage.getItem("usuario"));
      const plataforma = JSON.parse(sessionStorage.getItem("plataforma"));
      if (usuario && plataforma) {
        Crud_Catalogos(
          "usuarios_transportistas/usuario/" + usuario.id + "/plataforma/" + plataforma.id,
          "", "get", "", [], "", "", "", []
        ).then((transportistas) => {
          if (transportistas && transportistas.length > 0) {
            const transportistaValido = transportistas.find(t => t.idTransportista !== null);
            if (transportistaValido) {
              setIdTransportista(transportistaValido.idTransportista);
            }
          }
        }).catch(err => console.error("Error al cargar transportista:", err));
      }
    }

    // Cargar años para modelo
    let startYear = 1960;
    let year = new Date().getFullYear();
    let opcionesAnio = [];
    for (let i = year; i > startYear; i--) {
      opcionesAnio.push({ value: i, label: i });
    }
    setModeloOpciones(opcionesAnio);

    // Cargar colores
    Crud_Catalogos("colores", "", "get", "", [], "", "", "", []).then((returnVal) => {
      if (returnVal && Array.isArray(returnVal)) {
        let colorsTemp = [{ label: "Selecciona una opción", value: "" }];
        returnVal.forEach(color => {
          colorsTemp.push({
            label: color.nombreColor,
            value: color.nombreColor,
            id: color.idColor
          });
        });
        setColorsOpciones(colorsTemp);
      }
    });

    // Cargar marcas activas
    Crud_Catalogos("unidadesMarcasActivas", "", "get", "", [], "", "", "", []).then((returnVal) => {
      if (returnVal && Array.isArray(returnVal)) {
        let marcasTemp = [{ label: "Selecciona una opción", value: "" }];
        returnVal.forEach(marca => {
          marcasTemp.push({ label: marca.nombre, value: marca.nombre, id: marca.id });
        });
        setMarcaOpciones(marcasTemp);
      }
    });

    // Si es edición, cargar datos
    if (accion === "editar" && elementos) {
      setFormulario({
        placa: elementos.placa || "",
        economico: elementos.economico || "",
        marca: elementos.idUnidadMarca
          ? { label: elementos.idUnidadMarca.nombre, value: elementos.idUnidadMarca.nombre, id: elementos.idUnidadMarca.id }
          : null,
        color: elementos.color
          ? { label: elementos.color, value: elementos.color, id: elementos.idColor?.idColor }
          : null,
        modelo: elementos.modelo
          ? { label: elementos.modelo, value: parseInt(elementos.modelo) }
          : null
      });
    }

    // Si es nuevo pero se pasan elementos (vinculación desde histórico), pre-llenar
    if (accion === "nuevo" && elementos) {
      setFormulario(prev => ({
        ...prev,
        placa: elementos.placa || "",
        economico: elementos.economico || "",
        marca: elementos.idUnidadMarca?.nombre
          ? { label: elementos.idUnidadMarca.nombre, value: elementos.idUnidadMarca.nombre, id: elementos.idUnidadMarca?.id }
          : null,
        color: elementos.color
          ? { label: elementos.color, value: elementos.color }
          : null,
        modelo: elementos.modelo
          ? { label: elementos.modelo, value: parseInt(elementos.modelo) }
          : null
      }));
    }
  }, []);

  // Resolver id de marca/color cuando las opciones se cargan y hay nombre pre-llenado sin id
  useEffect(() => {
    if (formulario.marca && !formulario.marca.id && marcaOpciones.length > 0) {
      const match = marcaOpciones.find(m => m.label?.toUpperCase() === formulario.marca.label?.toUpperCase());
      if (match) {
        setFormulario(prev => ({ ...prev, marca: { ...prev.marca, id: match.id } }));
      }
    }
  }, [marcaOpciones, formulario.marca]);

  useEffect(() => {
    if (formulario.color && !formulario.color.id && colorsOpciones.length > 0) {
      const match = colorsOpciones.find(c => c.label?.toUpperCase() === formulario.color.label?.toUpperCase());
      if (match) {
        setFormulario(prev => ({ ...prev, color: { ...prev.color, id: match.id } }));
      }
    }
  }, [colorsOpciones, formulario.color]);

  // Función para vincular un tracto existente al transportista actual
  const vincularTractoExistente = async (placa, idTransp) => {
    try {
      // Buscar el tracto por placa en todos los tractos
      const todosTractos = await Crud_Catalogos("unidadTerNav", "", "get", "", [], "", "", "", []);
      if (!todosTractos || !Array.isArray(todosTractos)) {
        NotificationManager.error("Error al buscar tractos existentes", "Error");
        setCrudbutonEnable(true);
        return;
      }

      const tractoExistente = todosTractos.find(
        t => t.placa?.toUpperCase().trim() === placa.toUpperCase().trim()
      );

      if (!tractoExistente) {
        NotificationManager.error("Error al guardar el tracto", "Error");
        setCrudbutonEnable(true);
        return;
      }

      // Verificar si ya tiene relación con este transportista
      const relaciones = await Crud_Catalogos(
        "transportistas_unidades_ter_nav/id_unidad/" + tractoExistente.id,
        "", "get", "", [], "", "", "", []
      );

      if (Array.isArray(relaciones)) {
        const relacionActiva = relaciones.find(
          r => r.idTransportista === idTransp && r.estatus !== false
        );

        if (relacionActiva) {
          NotificationManager.info("Este tracto ya existe en tu catálogo", "Tracto existente");
          if (onSave) {
            onSave({
              id: tractoExistente.id,
              placa: tractoExistente.placa,
              economico: tractoExistente.economico,
              color: tractoExistente.color,
              modelo: tractoExistente.modelo,
              idUnidadMarca: tractoExistente.idUnidadMarca,
            });
          }
          cerrarModal();
          return;
        }

        // Verificar si tiene relación desactivada (para reactivar)
        const relacionDesactivada = relaciones.find(
          r => r.idTransportista === idTransp && r.estatus === false
        );

        if (relacionDesactivada) {
          const reactivado = await Crud_Catalogos(
            "transportistas_unidades_ter_nav/activar/" + tractoExistente.id + "/" + idTransp,
            "", "put", "", {}, "", "", "", []
          );
          if (reactivado !== false) {
            NotificationManager.success("Tracto vinculado exitosamente a tu catálogo", "Éxito");
            if (onSave) {
              onSave({
                id: tractoExistente.id,
                placa: tractoExistente.placa,
                economico: tractoExistente.economico,
                color: tractoExistente.color,
                modelo: tractoExistente.modelo,
                idUnidadMarca: tractoExistente.idUnidadMarca,
              });
            }
            cerrarModal();
            return;
          }
        }
      }

      // No tiene relación → crear nueva
      const nuevaRelacion = await Crud_Catalogos("transportistas_unidades_ter_nav", "", "post", "", {
        idUnidad: tractoExistente.id,
        idTransportista: idTransp
      }, "", "", "", []);

      if (nuevaRelacion !== false) {
        NotificationManager.success("Tracto vinculado exitosamente a tu catálogo", "Éxito");
        if (onSave) {
          onSave({
            id: tractoExistente.id,
            placa: tractoExistente.placa,
            economico: tractoExistente.economico,
            color: tractoExistente.color,
            modelo: tractoExistente.modelo,
            idUnidadMarca: tractoExistente.idUnidadMarca,
          });
        }
        cerrarModal();
      } else {
        NotificationManager.error("Error al vincular el tracto", "Error");
        setCrudbutonEnable(true);
      }
    } catch (error) {
      console.error("Error al vincular tracto existente:", error);
      NotificationManager.error("Error al vincular el tracto", "Error");
      setCrudbutonEnable(true);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    setCrudbutonEnable(false);

    // Si es vinculación (nuevo con elementos pre-llenados), intentar vincular por placa primero
    if (accion === "nuevo" && elementos && formulario.placa && idTransportista) {
      try {
        const todosTractos = await Crud_Catalogos("unidadTerNav", "", "get", "", [], "", "", "", []);
        if (todosTractos && Array.isArray(todosTractos)) {
          const tractoExistente = todosTractos.find(
            t => t.placa?.toUpperCase().trim() === formulario.placa.trim().toUpperCase()
          );
          if (tractoExistente) {
            // Ya existe en el catálogo global, vincular al transportista
            await vincularTractoExistente(formulario.placa.trim().toUpperCase(), idTransportista);
            return;
          }
        }
      } catch (err) {
        console.error("Error buscando tracto existente para vincular:", err);
        // Si falla la búsqueda, continuar con el flujo normal de creación
      }
    }

    const tractoDTO = {
      placa: (formulario.placa || "").trim().toUpperCase(),
      economico: (formulario.economico || "").trim(),
      color: formulario.color?.value || "",
      modelo: formulario.modelo?.value?.toString() || "",
      idUnidadMarca: {
        id: formulario.marca?.id || null
      },
      idColor: formulario.color?.id ? { idColor: formulario.color.id } : null,
      idUnidadTipo: { id: 28 },
      idUnidadEstatusOperacion: { id: 1 },
      estatus: true
    };

    // Si es edición, agregar el ID
    if (accion === "editar" && elementos?.id) {
      tractoDTO.id = elementos.id;
    }

    if (accion === "editar") {
      let resultado;
      if (idTransportista) {
        resultado = await Crud_Catalogos(
          `unidadTerNav/validar/${idTransportista}`, "", "put", "", tractoDTO, "", "", "", []
        );
        // Fallback si el endpoint con validación falla
        if (resultado === false && tractoDTO.id) {
          resultado = await Crud_Catalogos(
            `unidadTerNav/${tractoDTO.id}`, "", "put", "", tractoDTO, "", "", "", []
          );
        }
      } else if (tractoDTO.id) {
        resultado = await Crud_Catalogos(
          `unidadTerNav/${tractoDTO.id}`, "", "put", "", tractoDTO, "", "", "", []
        );
      }

      if (resultado !== false && resultado !== undefined) {
        NotificationManager.success("Tracto actualizado exitosamente", "Éxito");
        if (onSave) {
          onSave({
            id: elementos.id,
            placa: tractoDTO.placa,
            economico: tractoDTO.economico,
            color: tractoDTO.color,
            modelo: tractoDTO.modelo,
            idUnidadMarca: tractoDTO.idUnidadMarca,
          });
        }
        cerrarModal();
      } else {
        NotificationManager.error("Error al actualizar el tracto", "Error");
        setCrudbutonEnable(true);
      }
    } else {
      // Crear nuevo
      const response = await Crud_Catalogos("unidadTerNav", "", "post", "", tractoDTO, "", "", "", []);

      if (response !== false && response && response.id) {
        // Crear relación con transportista
        if (idTransportista) {
          const relacion = await Crud_Catalogos("transportistas_unidades_ter_nav", "", "post", "", {
            idUnidad: response.id,
            idTransportista: idTransportista
          }, "", "", "", []);

          if (relacion === false) {
            NotificationManager.warning(
              "Tracto creado pero no se pudo asignar al transportista",
              "Advertencia"
            );
          } else {
            NotificationManager.success("Tracto creado exitosamente", "Éxito");
          }
        } else {
          NotificationManager.success("Tracto creado exitosamente", "Éxito");
        }

        if (onSave) {
          onSave({
            id: response.id,
            placa: tractoDTO.placa,
            economico: tractoDTO.economico,
            color: tractoDTO.color,
            modelo: tractoDTO.modelo,
            idUnidadMarca: tractoDTO.idUnidadMarca,
          });
        }
        cerrarModal();
      } else {
        // Posible duplicado → intentar vincular tracto existente
        if (idTransportista && tractoDTO.placa) {
          vincularTractoExistente(tractoDTO.placa, idTransportista);
        } else {
          NotificationManager.error("Error al guardar el tracto", "Error");
          setCrudbutonEnable(true);
        }
      }
    }
  };

  return (
    <div className="tracto-form-container">
      <div className="tracto-header">
        <Icon name="truck" className="header-icon" />
        <h2>{accion === "nuevo" ? "Nuevo Tracto" : "Editar Tracto"}</h2>
      </div>

      <Form onSubmit={handleSubmit} className="tracto-form">
        <div className="form-section">
          <div className="form-row">
            <div className="form-field">
              <label className="field-label">
                <Icon name={accion === "editar" ? "lock" : "hash"} />
                Placa {accion === "editar" && (
                  <span style={{ fontSize: "11px", color: "#888", marginLeft: "4px" }}>
                    (no modificable)
                  </span>
                )}
              </label>
              <Form.Input
                name="placa"
                required
                value={formulario.placa}
                readOnly={accion === "editar"}
                onChange={(e) =>
                  accion !== "editar" &&
                  setFormulario({ ...formulario, placa: e.target.value.toUpperCase() })
                }
                placeholder="Ej: ABC123"
                style={accion === "editar" ? { backgroundColor: "#f0f0f0", cursor: "not-allowed" } : {}}
              />
            </div>

            <div className="form-field">
              <label className="field-label">
                <Icon name="tag" />
                Económico
              </label>
              <Form.Input
                name="economico"
                required
                value={formulario.economico}
                onChange={(e) => setFormulario({ ...formulario, economico: e.target.value })}
                placeholder="Ej: TRC-001"
              />
            </div>
          </div>

          <div className="form-field">
            <label className="field-label">
              <Icon name="award" />
              Marca
            </label>
            <Select
              name="marca"
              value={formulario.marca}
              onChange={(val) => setFormulario(prev => ({ ...prev, marca: val }))}
              options={marcaOpciones}
              menuPortalTarget={document.body}
              menuPosition="fixed"
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 100001 }) }}
              placeholder="Selecciona una opción"
            />
          </div>

          <div className="form-field">
            <label className="field-label">
              <Icon name="circle" />
              Color
            </label>
            <Select
              name="color"
              value={formulario.color}
              onChange={(val) => setFormulario(prev => ({ ...prev, color: val }))}
              options={colorsOpciones}
              menuPortalTarget={document.body}
              menuPosition="fixed"
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 100001 }) }}
              placeholder="Selecciona una opción"
            />
          </div>

          <div className="form-field">
            <label className="field-label">
              <Icon name="calendar" />
              Modelo (Año)
            </label>
            <Select
              name="modelo"
              value={formulario.modelo}
              onChange={(val) => setFormulario(prev => ({ ...prev, modelo: val }))}
              options={modeloOpciones}
              menuPortalTarget={document.body}
              menuPosition="fixed"
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 100001 }) }}
              placeholder="Selecciona una opción"
            />
          </div>
        </div>

        <div className="form-actions">
          <Button type="submit" color="primary" disabled={!crudbutonEnable}>
            <Icon name="save" />
            {accion === "nuevo" ? " Guardar" : " Actualizar"}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default TractosForm;
